import Configuration from '@/configuration'
import { _axios } from '../plugins/axios'
import { globals } from '../main.js'

const Vue = {}
Vue.axios = _axios

function makeRequest(callback) {
  return globals.$authService
    .getAccessToken()
    .then((response) => {
      callback(response)
    })
    .catch(function (error) {
      //Acquire token silent failure, send an interactive request.
      new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export default {
  async removeUndecidedApprovalOfRemovedApprover(mocId, user) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          data: user,
          url: Configuration.value('approvalEndPoint').concat(`/api/Approval/removeUndecidedApprovalOfRemovedApprover/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async save(data) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          data: data,
          url: Configuration.value('approvalEndPoint').concat(`/api/Approval/SetDecision/${data.mocId}/${data.decisionPass}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getAllApprovals(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          body: '',
          url: Configuration.value('approvalEndPoint').concat(`/api/Approval/GetAllApprovalsForMoc/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getApprovalCounts(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          body: '',
          url: Configuration.value('approvalEndPoint').concat(`/api/Approval/GetApprovalCounts/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getApprovalVersionFile(communityAbbreviation, mocId, version) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('approvalEndPoint').concat(
            `/api/Approval/GetApprovalVersion/${communityAbbreviation}/${mocId}/${version}`
          ),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getApprovalPassCounts(mocId, pass) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          body: '',
          url: Configuration.value('approvalEndPoint').concat(`/api/Approval/GetApprovalPassCounts/${mocId}/${pass}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getPendingApprovalsMOCDashboardCount(communityShortName) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('approvalEndPoint').concat(
            `/api/Approval/GetPendingApprovalsMOCDashboardCount/${communityShortName}`
          ),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async paginatePendingApprovalsMOCDashboard(communityShortName, params, cancelToken) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('approvalEndPoint').concat(
            `/api/Approval/PaginatePendingApprovalsMOCDashboard/${communityShortName}`
          ),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          params,
          cancelToken
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async haveAllMandatoryApproversVoted(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          body: '',
          url: Configuration.value('approvalEndPoint').concat(`/api/Approval/HaveAllMandatoryApproversVoted/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  }
}
